import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[actionsHost]',
})
export class ActionsDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
